module.exports = __webpack_public_path__ + "img/EYE.a1375f69.svg";